import { Component } from '@angular/core';
@Component({
  selector: 'cat-footer',
  templateUrl: './footer.component.html',
})
export class FooterComponent { }


// WEBPACK FOOTER //
// F:/SVNNew/Web/Phoenix HealthCare/HealthCare_UI/src/app/components/footer/footer.component.ts